<app-server-grid *ngIf="invoicesServerRequest && isThirdParty" [configuration]="invoicesGridConfiguration" 
                 [(request)]="invoicesServerRequest"
                 [refresh]="refreshGrid">
</app-server-grid>
